import { combineReducers } from "redux";
import userReducer from "./user/reducer";
import userPersistReducer from "./user/reducerPersist";
import accountReducer from "./account/reducer";

export default combineReducers({
    user: userReducer,
    userPersist: userPersistReducer,
    account: accountReducer,
});